import BaseApi from './BaseApi'

class PaginationApi extends BaseApi {
  getPaginatedData (baseUrl, additionalQueryArr = [], pageNum) {
    let url = baseUrl + `?page=${pageNum}`
    additionalQueryArr.forEach(query => {
      url += `&${query}`
    })
    return this.get(url)
  }
}

export default new PaginationApi()
